var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 12C14.1569 12 15.5 10.6569 15.5 9C15.5 7.34315 14.1569 6 12.5 6C10.8431 6 9.5 7.34315 9.5 9C9.5 10.6569 10.8431 12 12.5 12Z",
    fill: "black",
    fillOpacity: 0.95
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 14H9.5C8.96957 14 8.46086 14.2107 8.08579 14.5858C7.71071 14.9609 7.5 15.4696 7.5 16C7.5 16.5304 7.71071 17.0391 8.08579 17.4142C8.46086 17.7893 8.96957 18 9.5 18H15.5C16.0304 18 16.5391 17.7893 16.9142 17.4142C17.2893 17.0391 17.5 16.5304 17.5 16C17.5 15.4696 17.2893 14.9609 16.9142 14.5858C16.5391 14.2107 16.0304 14 15.5 14Z",
    fill: "black",
    fillOpacity: 0.95
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M19.5 4H5.5C3.84315 4 2.5 5.34315 2.5 7V17C2.5 18.6569 3.84315 20 5.5 20H19.5C21.1569 20 22.5 18.6569 22.5 17V7C22.5 5.34315 21.1569 4 19.5 4Z",
    fill: "black",
    fillOpacity: 0.95
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeak);
export default __webpack_public_path__ + "static/media/speak.ce0c702499700defb7938ec15e8325de.svg";
export { ForwardRef as ReactComponent };